import { render } from "./Inquiry.m.vue?vue&type=template&id=76b2173e&scoped=true"
import script from "./Inquiry.m.vue?vue&type=script&lang=js"
export * from "./Inquiry.m.vue?vue&type=script&lang=js"

import "./Inquiry.m.vue?vue&type=style&index=0&id=76b2173e&scoped=true&lang=css"

import exportComponent from "/Users/sung-hojang/git-projects/blackpay-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76b2173e"]])

export default __exports__